import {Component, OnInit} from '@angular/core';
import {FeatureSet} from "../../core/statistics-page-menu/statistics-page-menu.component";
import {environment} from "../../../environments/environment";
import {map} from "rxjs/operators";
import {ProductKpiService} from "../services/product-kpi.service";
import {KPIS} from '../../core/kpi-modules';
import { of } from 'rxjs';

@Component({
  selector: 'cintas-avg-lifetime-delta',
  templateUrl: './avg-lifetime-delta.component.html',
  styleUrls: ['./avg-lifetime-delta.component.scss']
})
export class AvgLifetimeDeltaComponent implements OnInit {

  items$;

  features: FeatureSet = {
    export: true
  };

  chartInfo = KPIS.productLifetimeDelta.description;

  view = environment.theme.baseView;
  colorScheme = environment.theme.colorPalette;

  constructor(private productService: ProductKpiService) {
  }

  ngOnInit() {
    this.items$ = this.productService.getAvgRemaingLifetimePerProduct().pipe(
      map((res: any) => res.data)
    );
    this.items$ = of([
      // {
      //   name: 'Sweat Jacket XL',
      //   no_items_in_group: 150,
      //   expected_lifetime: 500, // Expected lifetime in cycle counts
      //   avg_cycle_count: 417.6,    // Average cycle count reflects usage
      //   value: 31.27                 // Positive value indicates worth
      // },
    
      {
        name: 'Sweat Jacket L',
        no_items_in_group: 90,
        expected_lifetime: 500,
        avg_cycle_count: 450,    // Slightly above average due to higher usage
        value: 35
      },
    
      {
        name: 'Sweat Jacket M',
        no_items_in_group: 150,
        expected_lifetime: 500,
        avg_cycle_count: 475.8,    // Close to expected lifetime
        value: 2.7
      },
    
      {
        name: 'Sweat Jacket S',
        no_items_in_group: 60,
        expected_lifetime: 500,
        avg_cycle_count: 490,    // Very close to max expected lifetime
        value: -15
      },
    
      // {
      //   name: 'Poloshirt XL',
      //   no_items_in_group: 3,
      //   expected_lifetime: 400,
      //   avg_cycle_count: 361.6,     // Below expected lifetime due to lower durability
      //   value: -11.6                // Negative value indicates depreciation
      // },
    
      {
        name: 'Poloshirt L',
        no_items_in_group: 120,
        expected_lifetime: 400,
        avg_cycle_count: 375.3,     // Slightly below expected lifetime
        value: 15.3                 // Slightly negative value, still usable but less desirable
      },
    
      {
        name: 'Poloshirt M',
        no_items_in_group: 200,
        expected_lifetime: 400,
        avg_cycle_count: 390.8,     // Closer to expected but still below
        value: 5.9                  // Positive value indicates some worth
      },
    
      {
        name: 'Poloshirt S',
        no_items_in_group: 80,
        expected_lifetime: 400,
        avg_cycle_count: 256.8,     // Exactly at expected lifetime
        value: 28.8                  // Positive value indicating full worth
      },

      {
        name: 'Sweat Pants M',
        no_items_in_group: 250,
        expected_lifetime: 400,
        avg_cycle_count: 256.8,     // Exactly at expected lifetime
        value: 18.7                  // Positive value indicating full worth
      },

      {
        name: 'Sweat Pants S',
        no_items_in_group: 100,
        expected_lifetime: 400,
        avg_cycle_count: 256.8,     // Exactly at expected lifetime
        value: -8.8                  // Positive value indicating full worth
      },

      {
        name: 'Sweat Pants L',
        no_items_in_group: 150,
        expected_lifetime: 400,
        avg_cycle_count: 256.8,     // Exactly at expected lifetime
        value: 24.3                  // Positive value indicating full worth
      },
    
      // Example additional products with negative values
      // {
      //   name: 'Product B',
      //   no_items_in_group: 75,
      //   expected_lifetime: 300,
      //   avg_cycle_count: 250,     // Close to expected but below
      //   value: -15                // Negative value indicating poor performance
      // },
      // {
      //   name: 'Product C',
      //   no_items_in_group: 50,
      //   expected_lifetime: 200,
      //   avg_cycle_count: 180,     // Close to expected
      //   value: 5                  // Low positive value, indicating limited worth
      // }
    ]);
    
  }

  onSelect(event) {
    console.log(event);
  }

}
